import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const AdvanceTreesPage: React.FC = () => {
 return (
    <div className={styles.container}>
      <h1 className={styles.title}>Advance Trees</h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title='Minimum Heap'
          description='A binary tree where each parent is smaller than its children, ensuring the minimum value is always at the root.'
          link ='/advancetrees/minheap'
          icon='⚡️'
          />
        <TopicCard
          title='Maxium Heap'
          description='A binary tree where each parent is larger than its children, keeping the maximum value at the root.'
          link ='/advancetrees/maxheap'
          icon='🔺'
          />
        <TopicCard
          title='Tries'
          description='A prefix-based tree structure used for efficient word storage, autocomplete, and fast string lookups.'
          link ='/advancetrees/tries'
          icon='🔤'
          />
          <TopicCard
          title='Compare Advance Trees'
          description='Visualize how Min-Heaps, Max-Heaps, and Tries differ in structure, rules, and data retrieval behavior.'
          link ='/advancetrees/compareadvancetrees'
          icon='⚖️'
          />
      </div>
    </div>
  );
};

export default AdvanceTreesPage;